import http from 'plugins/axios'

export default {
  getUserList({
    page = 1,
    size = 25,
    queryType,
    queryValue,
    realName,
    userStatus,
    userType,
    mark,
  }) {
    return http.get({
      url: `/ta/admin/tenant/trade/user/${page}/${size}`,
      data: {
        queryType,
        queryValue,
        realName,
        userStatus,
        userType,
        mark,
      },
    })
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/ta/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status,
      },
      dataType: 'form',
    })
  },
  updateBlocking({ id, status, content }) {
    return http.post({
      url: '/ta/admin/tenant/trade/user/updateUserStatus',
      data: {
        id,
        userStatus: status,
        content: content,
      },
      dataType: 'form',
    })
  },
  cancelGoogle(data) {
    return http.post({
      url: '/ta/admin/user/delete/googleAuth',
      data,
      dataType: 'form',
    })
  },
  coutryCode() {
    return http.get({
      url: '/ta/admin/tenant/countryCodeList',
    })
  },
  updatInfo(data) {
    return http.post({
      url: '/ta/admin/user/update/tel',
      data,
      dataType: 'form',
    })
  },
  updateUserType(data) {
    return http.post({
      url: '/ta/admin/user/userType/update',
      data,
      dataType: 'form',
    })
  },
  updateDividendStatus(data) {
    return http.post({
      url: '/ta/admin/user/dividend/status/update',
      data,
      dataType: 'form',
    })
  },
  setNode(data) {
    return http.post({
      url: '/ta/admin/starplan/create/node',
      data,
      dataType: 'form',
    })
  },
  resetPassword(data) {
    return http.post({
      url: '/ta/admin/user/password/reset',
      data,
      dataType: 'form',
    })
  },
  updateMark(data) {
    return http.post({
      url: '/ta/admin/tenant/user/mark',
      data,
      dataType: 'form',
    })
  },
  addUser({ email, pwd, vipLevel }) {
    const data = {
      email,
      pwd,
    }
    if (vipLevel !== undefined && vipLevel !== null && vipLevel !== '') {
      data.vipLevel = vipLevel
    }
    return http.post({
      url: '/ta/admin/tenant/trade/user/save',
      data,
      dataType: 'form',
    })
  },
  getMockProfitBonusLevelOptions() {
    return http.get({ url: '/ta/admin/tenant/trade/user/mockProfitBonusLevel/options' })
  },
  updateMockProfitBonusLevel(data) {
    return http.post({
      url: '/ta/admin/tenant/trade/user/mockProfitBonusLevel/update',
      data,
      dataType: 'form',
    })
  },
  updateMockVipLevel({ id, vipLevel }) {
    return http.post({
      url: '/ta/admin/tenant/trade/user/mockVipLevel/update',
      data: {
        id,
        vipLevel,
      },
      dataType: 'form',
    })
  },
  showAccount({ userId, googleCode }) {
    return http.get({
      url: `/ta/admin/user/telOrEmail?userId=${userId}&googleCode=${googleCode}`,
    })
  },
  delPositionId(positionId) {
    return http.post({
      url: `/ta/admin/channel/position/deleteHistory?positionId=${positionId}`,
    })
  },
}
